import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { OiqUiAlertDialogService, OiqUiNotificationService } from '@oiq-ui-sdk/ui';
import { OIQ_FORM_ERROR_MAP, OIQ_FORM_DEFAULT_ERRORS } from '@oiq-ui-sdk/form';


import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { AuthFacade } from './core/auth/auth.facade';

export const appConfig: ApplicationConfig = {
  providers: [
    OiqUiNotificationService,
    OiqUiAlertDialogService,
    { provide: OIQ_FORM_ERROR_MAP, useValue: OIQ_FORM_DEFAULT_ERRORS },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Switching organization navigates home even when the user is already
    // there; without this the router drops the navigation and the guards never
    // re-evaluate the newly selected organization.
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideAnimationsAsync(),
    provideToastr(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Blocks bootstrap on one refresh call, so the first navigation already
    // knows whether there is a session. Without it every guarded route would
    // bounce to /login on reload while the answer was still in flight.
    provideAppInitializer(() => inject(AuthFacade).bootstrap()),
  ]
};
